import AsyncStorage from "@react-native-async-storage/async-storage";
import * as Print from "expo-print";
import React, { useEffect, useState } from "react";
import {
  Image,
  Linking,
  Text,
  TouchableOpacity,
  View,
  FlatList,
} from "react-native";
import QRCode from "react-native-qrcode-svg";
import moment from "moment";
import "moment/locale/pt-br";
import logoGpxTecInvest from "../../../assets/logo-gpx-exchange.png";
import logoLetItTrees from "../../../assets/logo-let-it-trees.png";
import { FormattedMessage, Useintl, useIntl } from "react-intl";
import HeaderTabs from "../../components/HeaderTabs";
import api from "../../services/api";
import translationService from "../../services/translationService";
import styles from "./styles";
import { If, Then, Else } from "react-if";
import Carbo from "../../svgs/Carbo";

const CertificatesEmit = ({ navigation, route }) => {
  const [now, setNow] = useState("");
  const [loading, setIsLoading] = useState("");
  const [translatedDescription, setTranslatedDescription] = useState("");
  const [translatedTitle, setTranslatedTitle] = useState("");
  const [translatedSubtitle, setTranslatedSubtitle] = useState("");
  const [translatedFooter, setTranslatedFooter] = useState("");
  const certType = route.params?.certType || "compensation";
  const isOwnershipCert = certType === "ownership";

  const fetchTranslations = async (data) => {
    if (!data?.actives || data.actives.length === 0) return;

    const title = data.actives[0]?.certificate_title || "";
    const subtitle = data.actives[0]?.certificate_subtitle || "";
    const footer = data.actives[0]?.certificate_footer || "";

    try {
      const translatedTitleText = await translationService.translate(title);
      const translatedSubtitleText = await translationService.translate(
        subtitle
      );
      const translatedFooterText = await translationService.translate(footer);

      setTranslatedTitle(translatedTitleText);
      setTranslatedSubtitle(translatedSubtitleText);
      setTranslatedFooter(translatedFooterText);
    } catch (error) {
      console.error("Error translating certificate data:", error);
    }
  };

  const fetchTranslatedDescription = async (data) => {
    if (!data?.actives || data.actives.length === 0) return;
    let text = data.actives[0].certificate_description;
    text = text.replaceAll("{ano}", year);
    text = text.replaceAll("{quantidade}", valueToken);

    let start = 0;
    while (start !== -1) {
      start = text.indexOf("{quantidade*");
      if (start !== -1) {
        let end = text.indexOf("}");
        let substr = text.substring(start, end + 1);
        let removedKeys = substr.replace("{", "").replace("}", "");
        let splitted = removedKeys.split("*");
        text = text.replace(substr, parseInt(splitted[1]) * valueToken);
      }
    }

    const translatedText = await translationService.translate(text);
    setTranslatedDescription(translatedText);
    setIsLoading(false);
  };

  useEffect(() => {
    formatDate();
    getLanguage();
    fetchCertificateData();
    getDataUsers();
    getCertificates();
  }, []);

  useEffect(() => {
    if (certificateUuid && lang) {
      handleOpenCertificate(certificateUuid, lang);
    }
  }, [certificateUuid, lang]);

  const formatDate = async () => {
    const lang = await AsyncStorage.getItem("lang");

    if (lang === "en") {
      // Formato Americano (MM/DD/YY)
      setNow(moment().format("MM/DD/YY"));
    } else {
      // Formato Europeu (DD/MM/YY)
      setNow(moment().format("DD/MM/YY"));
    }
  };

  useEffect(() => {
    formatDate();
  }, []);

  const {
    idCoin,
    qtd: valueToken,
    year,
    endorsed,
    cryptoQuantity,
    isCryptoactive: isCryptoactive = !isCryptoactive,
  } = route.params;

  const [name, setName] = useState("");
  const [certificateUuid, setCertificateUuid] = useState("");
  const [qrcodeImage64, setQrcodeImage64] = useState("");

  const [certificateData, setCertificateData] = useState();
  const [lang, setLang] = useState();
  function getQuantityEqaution(quantity, value, operation) {
    if (operation === "multiply") return quantity * value;
    if (operation === "divide") return quantity / value;
    return quantity;
  }

  const headers = (token) => ({
    headers: { Authorization: `Bearer ${token}` },
  });

  const fetchCertificateData = async () => {
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    const { data } = await api.get(`actives/${idCoin}`, headers(token));

    setCertificateData(data);
    fetchTranslatedDescription(data);
    await fetchTranslations(data);

    return data;
  };

  const intl = useIntl();
  const [isEndorser, setIsEndorser] = useState(false);

  useEffect(() => {
    async function loadEnderser() {
      const ie = await AsyncStorage.getItem("is_endorser");
      setIsEndorser(ie == "true");
    }
    loadEnderser();
  }, []);

  const getCertificates = async () => {
    const token = await AsyncStorage.getItem("JWT_TOKEN");

    var body = {
      idCoin,
      qtd: valueToken,
      year: year,
      endorsed: endorsed,
      isOwnershipCert: isOwnershipCert,
    };

    api.post("certificates", body, headers(token)).then((res) => {
      if (res.data.uuid) {
        setCertificateUuid(res.data.uuid);
      }
    });
  };

  const getDataUsers = async () => {
    const token = await AsyncStorage.getItem("JWT_TOKEN");

    api
      .get(`/clients/getDetails/client`, headers(token))
      .then((res) => {
        if (res.data.user[0].client.last_name) {
          setName(
            `${res.data.user[0].client.first_name} ${res.data.user[0].client.last_name}`
          );
        } else {
          setName(`${res.data.user[0].client.first_name}`);
        }
      })
      .catch((error) => {
        toast(
          intl.formatMessage({ id: "certificatesemit.houveErro" }),
          "#DA1414"
        );
      });
  };

  let svg = "";

  const getCertificateDescription = async () => {
    console.log("certificate data", certificateData);
    if (!certificateData?.actives || certificateData?.actives.length === 0) {
      return "";
    }
    let text = certificateData?.actives[0]?.certificate_description;

    text = text.replaceAll("{ano}", year);
    text = text.replaceAll("{quantidade}", valueToken);
    let start = 0;
    while (start !== -1) {
      start = text.indexOf("{quantidade*");
      if (start !== -1) {
        let end = text.indexOf("}");
        let substr = text.substring(start, end + 1);
        let removedKeys = substr.replace("{", "").replace("}", "");
        let spplited = removedKeys.split("*");
        text = text.replace(substr, parseInt(spplited[1]) * valueToken);
      }
    }

    //const translatedText = await translationService.translate(text);
    return text;
  };
  const getLanguage = async () => {
    try {
      const lang = await AsyncStorage.getItem("lang");
      if (lang) {
        setLang(lang);
      }
    } catch (error) {
      console.error("Error fetching language from AsyncStorage:", error);
    }
  };

  useEffect(() => {
    getLanguage();
  }, []);

  const HtmlCertificate = () => {
    function getDataURL() {
      return svg.toDataURL(callback);
    }
    function callback(dataURL) {
      setQrcodeImage64(dataURL);
    }
    useEffect(() => {
      //   getDataURL()
    }, []);

    const ODS_IMAGES = {
      1: require("../../../assets/imgs/1.png"),
      2: require("../../../assets/imgs/2.png"),
      3: require("../../../assets/imgs/3.png"),
      4: require("../../../assets/imgs/4.png"),
      5: require("../../../assets/imgs/5.png"),
      6: require("../../../assets/imgs/6.png"),
      7: require("../../../assets/imgs/7.png"),
      8: require("../../../assets/imgs/8.png"),
      9: require("../../../assets/imgs/9.png"),
      10: require("../../../assets/imgs/10.png"),
      11: require("../../../assets/imgs/11.png"),
      12: require("../../../assets/imgs/12.png"),
      13: require("../../../assets/imgs/13.png"),
      14: require("../../../assets/imgs/14.png"),
      15: require("../../../assets/imgs/15.png"),
      16: require("../../../assets/imgs/16.png"),
      17: require("../../../assets/imgs/17.png"),
    };

    const odsArray = (certificateData?.actives[0]?.certificate_ods || "")
      .split(",")
      .map((item) => parseInt(item, 10))
      .filter(Number.isInteger);

    return (
      <View key={5} style={styles.container}>
        <View key={6} style={styles.view}>
          <Text key={1} style={styles.label}>
            <If condition={certType === "ownership"}>
              <Then>
                <FormattedMessage id="certificatesemit.certPosseTitulo" />
              </Then>
              <Else>
                {translatedTitle ||
                  certificateData?.actives[0]?.certificate_title}
              </Else>
            </If>
          </Text>
          <View style={styles.hr}></View>
          <Text key={2} style={styles.label1}>
            <If condition={certType === "ownership"}>
              <Then>
                <FormattedMessage id="certificatesemit.certPosseSubTitle" />
              </Then>
              <Else>
                {translatedSubtitle ||
                  certificateData?.actives[0]?.certificate_subtitle}
              </Else>
            </If>
          </Text>
          <Text key={3} style={styles.label}>
            {name}
          </Text>
          <If condition={certType === "compensation"}>
            <Then>
              <Text key={5} style={styles.label2}>
                {translatedDescription}
              </Text>
            </Then>
          </If>
          <Text key={7} style={styles.label3}>
            <FormattedMessage id="certificatesemit.saoJose" />
            {now}
          </Text>
          <View style={styles.signature}>
            <View style={{ flexDirection: "column", alignItems: "center" }}>
              <Image
                source={{
                  uri: "https://filesgpx.s3.us-east-2.amazonaws.com/static/assinatura_transparente.png",
                }}
                style={styles.signatureImg}
              />
              <View style={styles.signatureLine}></View>
              <View>
                <Text>GPX ECOFI</Text>
              </View>
            </View>
            <View>
              <Image
                style={styles.iconsFooter}
                resizeMode="contain"
                source={logoGpxTecInvest}
              />
            </View>
            <View>
              {lang === "it" && (
                <Image
                  style={styles.iconsFooter}
                  resizeMode="contain"
                  source={logoLetItTrees}
                />
              )}
            </View>
            <View style={{ flexDirection: "column", alignItems: "center" }}>
              <Text>
                <FormattedMessage id="certificatesemit.codigoCertificado" />
              </Text>
              <Text style={styles.green}>{certificateUuid}</Text>
            </View>
          </View>

          <Text key={8} style={styles.label3}>
            {"\n"}
            {translatedFooter ||
              certificateData?.actives[0]?.certificate_footer}
          </Text>

          <View>
            <FlatList
              data={odsArray}
              keyExtractor={(item) => item.toString()}
              renderItem={({ item }) => {
                const image = ODS_IMAGES[parseInt(item, 10)];
                return image ? (
                  <Image source={image} style={styles.image} />
                ) : null;
              }}
              numColumns={17}
            />
          </View>

          <Image
            style={styles.image}
            source={require("../../../assets/imgs/ODS.png")}
          />

          <View style={styles.footer}>
            <View style={styles.qrCodeContainer}>
              <QRCode
                size={55}
                getRef={(c) => (svg = c)}
                value={`http://api.gpxecofi.com.br/certificates/view/${certificateUuid}`}
              />
              <Text style={styles.qrCodeText}>
                <FormattedMessage id="certificatesemit.qrCodeEsteCertificado" />
              </Text>
            </View>

            <View style={styles.qrCodeContainer}>
              <QRCode
                size={55}
                getRef={(c) => (svg = c)}
                value={`https://filesgpx.s3.us-east-2.amazonaws.com/filesActives/qFMDeuMCgsYDQYf04euaRh2GAUjxntdvkIRv1Csd.pdf`}
              />
              <Text style={styles.qrCodeText}>
                <FormattedMessage id="certificatesemit.qrCodeDescriProjeto" />
              </Text>
            </View>
          </View>

          <If condition={certificateData?.actives[0]?.certificate_background}>
            <Then>
              <View style={styles.backgroundImage}>
                <Carbo width={400} height={400} />
              </View>
            </Then>
            <Else>
              <Image
                source={{
                  uri: certificateData?.actives[0]?.certificate_background,
                }}
                style={styles.imgBackground}
              />
            </Else>
          </If>
        </View>
      </View>
    );
  };

  const Baixar = () => {
    return (
      <>
        <View style={styles.contentBtn}>
          <TouchableOpacity onPress={printToFile} style={styles.btn}>
            <Text style={styles.textBtn}>
              <FormattedMessage id="certificatesemit.download" />
            </Text>
          </TouchableOpacity>
        </View>
      </>
    );
  };

  const handleOpenCertificate = (uuid, language) => {
    let url = window.location.href;
    let certificateURL = "";

    if (url.includes("localhost")) {
      certificateURL = `http://localhost/certificates/view/${uuid}`;
    } else if (url.includes("homol.gpxecofi.com.br")) {
      certificateURL = `https://api.homol.gpxecofi.com.br/certificates/view/${uuid}`;
    } else {
      certificateURL = `http://api.gpxecofi.com.br/certificates/view/${uuid}`;
    }

    if (language === "pt_BR") {
      certificateURL += "/pt_BR";
    } else if (language === "en") {
      certificateURL += "/en";
    } else if (language === "it") {
      certificateURL += "/it";
    } else {
      certificateURL += "/pt_BR";
    }
    if (certType === "ownership") {
      certificateURL += `?certType=${certType}`;
    }
    Linking.openURL(certificateURL);
  };
  const AbrirBandeiras = () => {
    return (
      <>
        <View style={styles.container}>
          <View style={styles.bandeirasBtnContainer}>
            <TouchableOpacity
              onPress={() => handleOpenCertificate(certificateUuid, "pt_BR")}
              key="pt_BR"
            >
              <Image
                source={require("../../../assets/flags/bandeira-br.png")}
                style={styles.flagIcon}
              />
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => handleOpenCertificate(certificateUuid, "en")}
              key="en"
            >
              <Image
                source={require("../../../assets/flags/bandeira-us.png")}
                style={styles.flagIcon}
              />
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => handleOpenCertificate(certificateUuid, "it")}
              key="it"
            >
              <Image
                source={require("../../../assets/flags/bandeira-it.png")}
                style={styles.flagIcon}
              />
            </TouchableOpacity>
          </View>
        </View>
      </>
    );
  };
  const Fechar = () => {
    return (
      <>
        <View style={styles.contentBtn}>
          <TouchableOpacity
            onPress={() => {
              if (isEndorser) {
                navigation.navigate("WalletEndorser");
              } else {
                navigation.navigate("Wallet");
              }
            }}
            style={styles.btn}
          >
            <Text style={styles.textBtn}>
              <FormattedMessage id="certificatesemit.fechar" />
            </Text>
          </TouchableOpacity>
        </View>
      </>
    );
  };

  const printToFile = async () => {
    const html = `
        <body
        style="background: url(https://docs.google.com/uc?export=download&id=1vTRq0ZqHA2RzwH-ThRZy4nzSSQAg_LYb) no-repeat center center; background-size:cover;font-family: Arial; color:#333; margin:0;padding:0">
              <div style="display:flex; padding-left:15px; padding-right:15px; justify-content:center;">
          <div
            style=" width: 100%; position:relative; overflow:hidden; margin: 50px; background-color: #fff; border: 1px solid #ccc; text-align: center;">
            <img style="width:80%; max-width:800px;position: absolute; top:50%; left:50%;transform: translate(-50%, -50%);"
              src="https://docs.google.com/uc?export=download&id=1Rx5sxmpMTWJEW-XMaKfPnDMe9sOiJUfw" alt="background logo" />
            <img src="https://docs.google.com/uc?export=download&id=1nPTufSlCjoPua3mEFEnHd497vlUzZGEQ" width=220
              style="margin-top:30; margin-bottom:30;margin-left:auto;margin-right:auto;" />
            <h1
              style="font-weight:normal; margin:0;font-family: Georgia; font-size:280%; margin-bottom:20px; text-align:center; ">
              Certificado de ${
                isCryptoactive
                  ? Neutralização
                  : certificateData?.actives[0]?.certificate_title
              }</h1>
            <hr style="width:50%; border-bottom: 2px;" />
            <p style="width:60%;font-family: Arial; font-size: 14px; text-align: center; margin: 30 auto;">
              GPX
              Tecnologia e Investimento por meio do programa de gerenciamento de gases do efeito estufa, confere o
              Certificado
              de Neutralização de Carbono à: </p>
            <p style="width:60%;font-family: Arial; font-size: 14px; text-align: center; margin: 30 auto;">
              ${certificateData?.actives[0]?.certificate_subtitle}</p>
            <p
              style="font-family: Georgia;font-size: 250%;margin-bottom: 20px;margin-top: 20px;text-align: center; font-weight: normal;">
              ${name}
            </p>
              style="font-size: 14px; margin-top:0; margin-bottom:0; margin-left: 15px; margin-right: 15px;text-align: center;">
              Quantidade de ativos: Descrição do ativo: ${
                certificateData?.actives[0]?.certificate_description
              }.</p>
            <br>
            <p
              style="font-size: 14px; margin-top:0; margin-bottom:0; margin-left: 15px; margin-right: 15px;text-align: center;">
              ${
                isCryptoactive &&
                `No total
              foram
              neutralizados
              ${
                valueToken * 1000
              }kg de CO² (${valueToken} crédito(s) de carbono) referente(s) ao ano de ${year}`
              }.</p>
            <p
              style="font-size: 14px; margin-top:0; margin-bottom:0; margin-left: 15px; margin-right: 15px;text-align: center;">
              Quantidade de ativos: ${cryptoQuantity} | ${getQuantityEqaution(
      cryptoQuantity,
      200,
      "divide"
    )}.</p>
            <p style="font-size:14px; margin-bottom:15px; margin-left: 15px;margin-right: 15px;text-align: center;">
              Florianópolis, ${now}</p>
            <div
              style="margin:0 auto; max-width:800px; display: flex; flex-direction: row; justify-content: space-around; align-items: center;">
              <div style="margin: 0 30">
                <img src="https://filesgpx.s3.us-east-2.amazonaws.com/static/assinatura_transparente.png" style="max-width: 80%; max-height: 45px; width: auto; height: auto; margin: 0 auto;"/>
                <hr style="width:228px; border-top:1px solid" />
                <p style="font-size: 14px;">GPX Tecnologia e Investimento</p>
              </div>
              <img src="https://docs.google.com/uc?export=download&id=1g8aiEXseQxLJIqJJVtnrvmAWqfBE_ks_" alt="carbon icon" />
              <div
                style="width:260px; font-size: 14px;margin-bottom: 15px;margin-left: 15px;margin-right: 15px;text-align: center;">
                <p>Código do Certificado<br>
                  <span style="color:#96B533">${certificateUuid}</span>
                </p>
              </div>
            </div>
                  <div style="height:60px; display: flex; flex-direction: row; justify-content: space-between; padding: 25px">
              <img style="width:60px; height:60px;" src="data:image/jpeg;base64,${qrcodeImage64}" />
              <img style="width: 190px;align-self: end;"
                src="https://docs.google.com/uc?export=download&id=1kvvp4w16Ob6FHL1zajxon4m-HBk0l2q4" alt="icons" />
            </div>
          </div>
        </div>
      </body>
        `;
    // On iOS/android prints the given html. On web prints the HTML from the current page.
    Print.Orientation.portrait;
    await Print.printToFileAsync({
      orientation: Print.Orientation.landscape,
      html: HtmlCertificate(),
    });
    //await shareAsync(uri, { UTI: '.pdf', mimeType: 'application/pdf' });
  };

  const Abrir = () => {
    return (
      <>
        <View style={styles.contentBtn}>
          <TouchableOpacity
            onPress={() => {
              window.open(
                `http://api.homol.gpxecofi.com.br/certificates/view/${certificateUuid}`,
                "_blank"
              );
            }}
            style={styles.btn}
          >
            <Text style={styles.textBtn}>
              <FormattedMessage id="certificatesemit.verBaixarOnline" />
            </Text>
          </TouchableOpacity>
        </View>
      </>
    );
  };

  return (
    <>
      <FormattedMessage id="certificatesemit.emissaoCertidicados">
        {(ec) => (
          <FormattedMessage id="certificatesemit.emissaoCertificadoSingular">
            {(ecs) => <HeaderTabs title={ecs} subtitle={ec} />}
          </FormattedMessage>
        )}
      </FormattedMessage>

      {/*  <View>
        <Text>Visualize seu certificado na carteira</Text>
        <TouchableOpacity
          onPress={() => navigation.navigate("Wallet", { tabIndex: 2 })}
          style={{ backgroundColor: "#F2F2F2" }}
        >
          <Text>Visualizar Certificado</Text>
        </TouchableOpacity>
      </View> */}
      {/*   {!isEndorser && (
        <ScrollView style={{ flex: 1 }}>
          <HtmlCertificate />
        </ScrollView>
      )} */}
      <View
        style={{
          alignSelf: "center",
          maxWidth: 320,
          minWidth: 320,
          paddingVertical: 16,
          paddingHorizontal: 16,
          borderWidth: 0.5,
          borderColor: "#FFF",
          borderRadius: 8,
          shadowColor: "#000",
          shadowOffset: {
            width: 0,
            height: 4,
          },
          shadowOpacity: 0.25,
          shadowRadius: 6,
          elevation: 4,
        }}
      >
        <Text
          style={{
            fontSize: 16,
            color: "#077A97",
            textAlign: "center",
            fontWeight: "bold",
          }}
        >
          <FormattedMessage id="certificatesemit.verBaixarOnline" />
        </Text>

        <View style={styles.viewAbrirBandeiras}>
          <If condition={certificateUuid}>
            <Then>
              <AbrirBandeiras />
            </Then>
            <Else>
              <Text>
                <FormattedMessage id="geral.txtCarregando" />
              </Text>
            </Else>
          </If>
          <Fechar />
        </View>
      </View>
    </>
  );
};

export default CertificatesEmit;
